import { MailOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Drawer, Form, Input } from 'antd';
import GlobalDivider from '../divider/GlobalDivider';


const ContactForSupport = ({ visible, onClose }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    form.resetFields();
    onClose();
  };

  return (
    <Drawer
      placement="right"
      onClose={onClose}
      open={visible}
      width={400}
      closable={false}
    >
      <GlobalDivider name="Contact for support" orientation="center" />
      <Form
        form={form}
        name="contact-form"
        onFinish={onFinish}
        layout="vertical"
        className="contact-form"
      >
        <Form.Item
          className="username"
          name="name"
          label="Your Name"
          rules={[{ required: true, message: 'Please enter your name' }]}
        >
          <Input prefix={<UserOutlined />} placeholder="Enter your name" />
        </Form.Item>
        <Form.Item
          className="username"
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Please enter a valid email' },
          ]}
        >
          <Input prefix={<MailOutlined />} placeholder="Enter your email" />
        </Form.Item>
        <Form.Item
          className="username"
          name="message"
          label="Message"
          rules={[{ required: true, message: 'Please enter your message' }]}
        >
          <Input.TextArea rows={4} placeholder="Enter your message" />
        </Form.Item>
        <Form.Item>
          <Button className="submit-button" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default ContactForSupport;
